import { FC } from 'react'

import { PickupDeliveryLocationResponseV1 } from '@forto-dev/customer-master-data-models'

import { LocationSearch } from './components/LocationSearch'
import {
  LocationSelectorContextProvider,
  LocationSelectorContextProviderProps,
} from './context/LocationSelectorContextProvider'
import { useLocationSelectorContext } from './context/useLocationSelectorContext'
import { useLocationSelectorDispatchContext } from './context/useLocationSelectorDispatchContext'
import { LocationAddDialog } from '../LocationList/LocationAddDialog'

const LocationSelectorInner: FC = () => {
  const { accountID, manualMode, manualActionProps } = useLocationSelectorContext()
  const { onAddNewCompleted } = useLocationSelectorDispatchContext()

  const onCloseAddLocationDialog = (newLocationID?: PickupDeliveryLocationResponseV1) => {
    onAddNewCompleted(newLocationID)
  }

  return (
    <>
      <LocationSearch />
      {manualMode && (
        <LocationAddDialog
          accountID={accountID}
          onClose={onCloseAddLocationDialog}
          title={manualActionProps?.dialogTitle}
          description={manualActionProps?.dialogDescription}
        />
      )}
    </>
  )
}

export type LocationSelectorProps = LocationSelectorContextProviderProps
export const LocationSelector: FC<LocationSelectorProps> = (props) => {
  return (
    <LocationSelectorContextProvider {...props}>
      <LocationSelectorInner />
    </LocationSelectorContextProvider>
  )
}
